/*
 * PARAK — Header behaviour
 *
 * Three things Horizon's header gave us for free and we now own:
 * transparent-to-solid on scroll, the mobile drawer toggle, and a live
 * cart count (Horizon's cart-icon.js/cart-bubble.liquid aren't used here).
 */

import { ThemeEvents } from '@theme/events';

function updateCartCount(event) {
  const nodes = document.querySelectorAll('[data-parak-cart-count]');
  if (!nodes.length) return;

  const itemCount = event.detail.data?.itemCount ?? 0;
  const comingFromProductForm = event.detail.data?.source === 'product-form-component';

  const newCount = comingFromProductForm
    ? (parseInt(nodes[0].textContent ?? '0', 10) || 0) + itemCount
    : itemCount;

  for (const node of nodes) node.textContent = String(newCount);
}

function initHeader() {
  const hdr = document.querySelector('[data-parak-hdr]');
  const toggle = document.querySelector('[data-parak-hdr-toggle]');
  const nav = document.querySelector('[data-parak-mobile-nav]');

  if (hdr && hdr.classList.contains('parak-hdr--transparent')) {
    const onScroll = () => hdr.classList.toggle('parak-hdr--solid', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (toggle && nav) {
    const setOpen = (open) => {
      nav.classList.toggle('parak-mnav--open', open);
      toggle.setAttribute('aria-expanded', String(open));
    };
    toggle.addEventListener('click', () => setOpen(!nav.classList.contains('parak-mnav--open')));
    for (const a of nav.querySelectorAll('a')) a.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });
    window.matchMedia('(min-width: 861px)').addEventListener('change', (e) => { if (e.matches) setOpen(false); });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeader);
} else {
  initHeader();
}

document.addEventListener(ThemeEvents.cartUpdate, updateCartCount);

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('[data-parak-hdr]')) initHeader();
});
